import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  onLinkClick(event) {
    const clickedElement = $(event.target).parent();
    const findElement = this.getParentsUntil(clickedElement[0], '.searchable-list-item');
    const elementToActivate = findElement.length > 0 ? $(findElement[0]) : clickedElement;
    $(this.element).find(".active-link").removeClass("active-link");
    elementToActivate.addClass("active-link");
  }

  getParentsUntil(el, selector) {
    let parents = [],
      _el = el.parentNode;
    while (_el && typeof _el.matches === 'function') {
      parents.unshift(_el);
      if (_el.matches(selector)) return parents;
      else _el = _el.parentNode;
    }
    return [];
  };

}
